import React from 'react';
import HeaderDropdownItem from '../../Components/Header/HeaderDropdown/HeaderDropdownItem';
import { UserProject } from '../../../../types/project.types';
import ListItemText from '@mui/material/ListItemText';
import { useWeaveThemeContext } from '../../theme/WeaveContext';
import { SecondarySpan } from './ProjectPicker.styles';
import { useProjects } from '../../../../hooks/useProjects';
export interface ProjectPickerItemProps {
	project: UserProject;
}

const ProjectPickerItem = ({ project, ...rest }: ProjectPickerItemProps) => {
	const {
		weaveThemeConsumer: { resolvedRoles },
		isWeaveTheme,
	} = useWeaveThemeContext();
	const color = isWeaveTheme
		? resolvedRoles['colorScheme.text.default']
		: 'white';
	const { switchProject } = useProjects();

	return (
		<HeaderDropdownItem
			_id={`project-picker-${project.name}`}
			cy={`project-picker-${project.name}`}
			closeMenu={() => {
				switchProject(project.sourceId);
			}}
			switchAction={() => {}}
			{...rest}>
			<ListItemText
				primary={project.name}
				style={{ minWidth: 200 }}
				secondary={
					<SecondarySpan color={color}>
						{project.hubName}
					</SecondarySpan>
				}
			/>
		</HeaderDropdownItem>
	);
};

export default ProjectPickerItem;
